export default __webpack_public_path__ + "media/img/bgicon_secondary-7c9361ec6e58957da00e5a6acce7503e.svg";